/* Footer link groups collapse into accordions on small screens. */
(function () {
  'use strict';
  var MQ = window.matchMedia('(max-width: 600px)');

  function groups() {
    var top = document.querySelector('.pc-foot-top');
    if (!top) return [];
    return Array.prototype.slice.call(top.children, 1);
  }

  function bind() {
    groups().forEach(function (col) {
      var h = col.querySelector('h4');
      if (!h || h.dataset.pcBound) return;
      h.dataset.pcBound = '1';
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');

      function toggle() {
        if (!MQ.matches) return;
        var open = col.classList.toggle('pc-open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  function reset() {
    groups().forEach(function (col) {
      var h = col.querySelector('h4');
      if (!MQ.matches) {
        col.classList.remove('pc-open');
        if (h) h.setAttribute('aria-expanded', 'true');
      } else if (h) {
        h.setAttribute('aria-expanded', col.classList.contains('pc-open') ? 'true' : 'false');
      }
    });
  }

  function init() { bind(); reset(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  if (MQ.addEventListener) MQ.addEventListener('change', reset);
  document.addEventListener('shopify:section:load', init);
})();
